import * as React from 'react';
import { Route, Switch} from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import utils from '../../utils/utils';

const Router = () => {

  const PublicLayout = utils.getRoute('/').component;
  const AppLayout = utils.getRoute('/user').component;
  const AdminLayout = utils.getRoute('/admin').component;

  return (
    <Switch>
      <ProtectedRoute path="/user" render={(props: any) => <AppLayout {...props} />} />
      <ProtectedRoute path="/admin" render={(props: any) => <AdminLayout{...props} />} />

      <Route path="/" render={(props: any) => <PublicLayout {...props} />} />
    </Switch>
  );
};

export default Router;
